export const environment = {
  production: true,
  localserve: false,
  basehost: 'https://corpers-online.herokuapp.com',
  baseurl: 'https://corpers-online.herokuapp.com/api/v1.0',
  CORP_MEMBER_SOCKET_ENDPOINT: '/corp-member',
  env: 'HEROKU',
};
